export const GET_POINT_ZONES = Symbol('GET_POINT_ZONES');
export const GET_POINT_ZONES_REQUEST = Symbol('GET_POINT_ZONES_REQUEST');
export const GET_POINT_ZONES_SUCCESS = Symbol('GET_POINT_ZONES_SUCCESS');
export const GET_POINT_ZONES_ERROR = Symbol('GET_POINT_ZONES_ERROR');

